var _circle, _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDarkMoon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 14,
    r: 14,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.0799 14.2021C21.2749 15.4239 20.9526 15.693 20.4578 16.8304C19.9631 17.9678 20.2746 18.8975 19.2444 19.5957C18.2141 20.2938 17.0062 20.6864 15.7618 20.7276C14.5174 20.7688 13.2881 20.4568 12.2177 19.8281C11.1473 19.1995 10.2801 18.2802 9.71755 17.1778C9.155 16.0754 8.92039 14.8355 9.04115 13.6032C9.16192 12.3709 9.63307 11.1972 10.3995 10.2194C11.1659 9.24159 12.1959 8.50011 13.3689 8.08174C12.908 9.20735 12.8682 10.4587 13.2568 11.6083C13.6454 12.7579 14.4366 13.7294 15.4864 14.3459C16.5362 14.9625 17.3756 15.8373 18.5779 15.6221C19.7803 15.4069 20.3076 15.1448 21.0799 14.2021Z",
    fill: "#DCF4E8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21 14.6306C20.8774 15.9574 20.3795 17.2218 19.5645 18.2759C18.7495 19.33 17.6512 20.1301 16.398 20.5828C15.1448 21.0354 13.7887 21.1218 12.4882 20.8319C11.1878 20.5419 9.99676 19.8875 9.05461 18.9454C8.11246 18.0032 7.45811 16.8122 7.16814 15.5118C6.87817 14.2113 6.96456 12.8552 7.41721 11.602C7.86986 10.3488 8.67005 9.2505 9.72413 8.43552C10.7782 7.62054 12.0426 7.12261 13.3694 7C12.5926 8.05088 12.2188 9.34566 12.316 10.6488C12.4132 11.952 12.9749 13.177 13.8989 14.1011C14.823 15.0251 16.048 15.5868 17.3512 15.684C18.6543 15.7812 19.9491 15.4074 21 14.6306Z",
    stroke: "url(#paint0_linear_1379_21262)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1379_21262",
    x1: 21.1898,
    y1: 4.24999,
    x2: 9.8086,
    y2: 4.77346,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5BC231"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0EBDB8"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDarkMoon);
export default __webpack_public_path__ + "static/media/darkMoon.816f15a715b294672883572f70f1b38b.svg";
export { ForwardRef as ReactComponent };